import React, { Component, Fragment } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { filterVaccineCenters } from "../../actions/vaccinecenterActions";

class VCFilter extends Component {
  state = {
    appointment: false,
    walkIn: false,
    driveThru: false,
    older75: false,
    eduChildCare: false,
    protServ: false,
    regular: false,
    popUp: false,
    chevron: false,
  };
  onChange = (e) => {
    if (e.target.value === "false") {
      this.setState({ [e.target.name]: !!e.target.value }, () => {
        const {
          appointment,
          walkIn,
          driveThru,
          older75,
          eduChildCare,
          protServ,
          regular,
          popUp,
        } = this.state;
        this.props.filterVaccineCenters(
          appointment,
          walkIn,
          driveThru,
          older75,
          eduChildCare,
          protServ,
          regular,
          popUp
        );
      });
    } else {
      this.setState({ [e.target.name]: !e.target.value }, () => {
        const {
          appointment,
          walkIn,
          driveThru,
          older75,
          eduChildCare,
          protServ,
          regular,
          popUp,
        } = this.state;
        this.props.filterVaccineCenters(
          appointment,
          walkIn,
          driveThru,
          older75,
          eduChildCare,
          protServ,
          regular,
          popUp
        );
      });
    }
  };
  render() {
    const {
      appointment,
      walkIn,
      driveThru,
      older75,
      protServ,
      eduChildCare,
      regular,
      popUp,
      chevron,
    } = this.state;
    return (
      <Fragment>
        <button
          className="btn filter-button btn-block"
          type="button"
          data-toggle="collapse"
          data-target="#collapseFilter"
          aria-controls="collapseFilter"
          aria-expanded="false"
          aria-label="Toggle navigation"
          name="chevron"
          onClick={this.onChange}
          value={chevron}
        >
          Filter Vaccine Centers{" "}
          <i
            style={{ float: "right", marginTop: "5px" }}
            className={classnames("fas fa-chevron-down", {
              "fa-chevron-up": chevron,
            })}
          ></i>
        </button>
        <div className="collapse show" id="collapseFilter">
          <div className="card card-body">
            <div className="row">
              <div className="col-md-6">
                <h6>Procedure</h6>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={appointment}
                    onChange={this.onChange}
                    name="appointment"
                    id="defaultCheck1"
                  />
                  <label className="form-check-label" htmlFor="defaultCheck1">
                    Appointment Required
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="walkIn"
                    value={walkIn}
                    onChange={this.onChange}
                    id="defaultCheck2"
                  />
                  <label className="form-check-label" htmlFor="defaultCheck2">
                    Walk Thru
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="driveThru"
                    value={driveThru}
                    onChange={this.onChange}
                    id="defaultCheck3"
                  />
                  <label className="form-check-label" htmlFor="defaultCheck3">
                    Drive Thru
                  </label>
                </div>
              </div>
              {/* <div className="col-md-6">
                <h6>Type of Vaccine Center</h6>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="regular"
                    value={regular}
                    onChange={this.onChange}
                    id="defaultCheck4"
                  />
                  <label className="form-check-label" htmlFor="defaultCheck4">
                    Regional Public Vaccineing
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="popUp"
                    value={popUp}
                    onChange={this.onChange}
                    id="defaultCheck5"
                  />
                  <label className="form-check-label" htmlFor="defaultCheck5">
                    Scheduled Pop-Up
                  </label>
                </div>
              </div> */}
              <div className="col-md-6">
                <h6>Recommendations</h6>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={older75}
                    name="older75"
                    onChange={this.onChange}
                    id="defaultCheck6"
                  />
                  <label className="form-check-label" htmlFor="defaultCheck6">
                    Age 75 and older
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={eduChildCare}
                    name="eduChildCare"
                    onChange={this.onChange}
                    id="defaultCheck7"
                  />
                  <label className="form-check-label" htmlFor="defaultCheck7">
                    Education & Child Care
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={protServ}
                    name="protServ"
                    onChange={this.onChange}
                    id="defaultCheck8"
                  />
                  <label className="form-check-label" htmlFor="defaultCheck8">
                    Protective Services Occupations
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
VCFilter.propTypes = {
  vaccinecenters: PropTypes.array.isRequired,
  filterVaccineCenters: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  vaccinecenters: state.vaccinecenter.vaccinecenters,
});

export default connect(mapStateToProps, {
  filterVaccineCenters,
})(VCFilter);
